export default {"src":"/_next/static/media/circularArrow.a40f6266.svg","height":34,"width":34};